import { UserSubscriptionTypes } from '../enums/UserSubscriptionTypes';

export const vipUsers: UserSubscriptionTypes[] = [
  UserSubscriptionTypes.admin,
  UserSubscriptionTypes.vip,
  UserSubscriptionTypes.platinum,
];
